import { render, staticRenderFns } from "./ProductContentSection.vue?vue&type=template&id=deb6f978&scoped=true&"
import script from "./ProductContentSection.vue?vue&type=script&lang=js&"
export * from "./ProductContentSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentSection.vue?vue&type=style&index=0&id=deb6f978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb6f978",
  null
  
)

export default component.exports